export class TerminalCommandModal {
  constructor(
    $scope,
    $modalInstance,
    $http,
    $timeout,
    $q,
    command,
    commandText,
  ) {
    $scope.restarting = false;
    $scope.restartFailed = false;
    $scope.command = command;
    $scope.commandText = commandText;

    const sendCommandSignal = () => {
      const deferred = $q.defer();
      $http({
        method : 'POST',
        url    : '/analytics/do_terminal_command/',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        data   : $.param({
          terminal_command: command,
        }),
      }).then(function ({data}) {
        deferred.resolve('Command executed');
      }).catch(function ({data, headers, config}) {
        console.log(data);
        console.log(headers);
        console.log(config);
        deferred.reject('Command not executed');
        $scope.restarting = false;
        $scope.restartFailed = true;
      });
      return deferred.promise;
    };

    const checkServer = (deferred) => {
      $http.get('/analytics/do_terminal_command/')
        .then(function () {
          deferred.resolve('Staffcop is up');
        })
        .catch(function () {
          deferred.notify('Staffcop is not up');
        });
    };

    $scope.fromData = (data) => {
      $scope.message = command;
    };

    $scope.init = () => {
      $scope.fromData({});
    };

    $scope.ok = (action) => {
      $scope.restarting = true;
      sendCommandSignal().then(
        function (result) {
          $timeout(function () {
            const deferred = $q.defer();
            checkServer(deferred);
            deferred.promise.then(
              function (result) {
                window.location = '/';
              },
              function (result) {
                // console.log(result);
              },
              function (result) {
                if (result === 'Staffcop is not up') $timeout(function () {
                  checkServer(deferred);
                }, 1000);
              },
            );
          }, 1000);
        },
      )
        .catch((err) => {
          console.error(err);
        });
    };

    $scope.close = () => {
      $modalInstance.close();
    };
  }
}



// WEBPACK FOOTER //
// ./src/admin/terminal-command-modal.component.js